<template>
    <v-card v-if="!asButton" link tile flat class="sidenav card" :class="{ 'is-active': isActive }" :to="route">
        <div class="sidenav-content">
            <v-badge v-if="hasCount" :color="countColor" :content="count" location="top right">
                <v-icon size="26">{{ icon }}</v-icon>
            </v-badge>
            <v-icon v-else size="26">{{ icon }}</v-icon>
            <div class="sidenav-title" v-text="title"></div>
        </div>
    </v-card>

    <v-btn v-else :to="route" class="bottombar_btn" :class="{ 'is-active': isActive }">
        <span>{{ title }}</span>
        <v-badge v-if="hasCount" :color="countColor" :content="count" location="top right">
            <v-icon>{{ icon }}</v-icon>
        </v-badge>
        <v-icon v-else>{{ icon }}</v-icon>
    </v-btn>
</template>


<script>
export default {
    name: 'NavTile',
    props: {
        title: String,
        icon: String,
        route: [Object, String],
        count: [Number, String],
        countColor: {
            type: String,
            default: 'red',
        },
        asButton: Boolean,
    },
    components: {},

    data() {
        return {};
    },

    methods: {},

    computed: {
        hasCount() {
            return Number(this.count) > 0;
        },
        isActive() {
            return this.route?.name == this.$route?.name;
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped>
/*
.sidenav.card {
  border-bottom: 1px solid #e0e0e0;
}
*/

.sidenav.card {
    border-radius: 0;
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.sidenav-content {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    min-height: 90px;
    padding: 12px 6px;
}

.sidenav-title {
    font-size: 0.86rem;
    line-height: 1.2;
    max-width: 100%;
    overflow-wrap: anywhere;
    text-align: center;
}

.sidenav.card:hover {}

.sidenav.card.is-active {
    opacity: 1;
    color: rgb(var(--v-theme-primary));
}

.sidenav.card.is-active::before,
.sidenav.card.is-active::after {
    content: "";
    position: absolute;
    z-index: 10;
    height: 100%;

}

.sidenav.card.is-active::before {
    width: 7px;
    opacity: 1;
    border-radius: 2px;
    background-color: rgb(var(--v-theme-primary));
}

.sidenav.card.is-active::after {
    width: 100%;
    top: 0;
    opacity: 0.03;
    background-color: black;
}

.bottombar_btn.is-active {
    color: rgb(var(--v-theme-primary)) !important;
}
</style>